/**
 *
 */

import React, { useState, useEffect } from "react";

/* Import configuration starts */
/* Import configuration ends */

/* Import redux slices component starts */
/* Import redux slices component ends */

/* Import react bootstrap component starts */
/* Import react bootstrap component ends */

/* Import MUI component starts */
/* Import MUI component ends */

/* Import image and SVG starts */
/* Import image and SVG ends */

/* Import local pages and component starts */
/* Import local pages and component ends */

import "./style.scss";

/* Component starts */
const SliderButton = (props) => {
  /* Props destructuring starts */
  const { active, onChange = null, setValue = null, disabled = false } = props;
  /* Props destructuring ends */

  /* Component states and useRef declaration starts */
  /* Component states and useRef declaration ends */

  /* Other hooks declaration starts */
  /* Other hooks declaration ends */

  /* Component variable declaration / object destructure starts */
  /* Component variable declaration / object destructure ends */

  /* Component function definition starts */
  /* Component function definition ends */

  /* Component useEffect starts */
  const onSlide = (e) => {
    onChange && onChange(!active, active, e);
    setValue && setValue(!active);
  };
  /* Component useEffect ends */

  /* ************* Component rendering. JSX code ************* */
  return (
    <div
      className={`slider-button-component-wrapper ${disabled ? "diabled" : ""}`}
    >
      <input
        type="checkbox"
        onChange={onSlide}
        checked={active}
        disabled={disabled}
      />
    </div>
  );
};
/* Component ends */

export default SliderButton;
